/**
 * Routini API — Management
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TaxiTripAssignmentStrategy = {
    Manual: 'Manual',
    Greedy: 'Greedy',
    DaySolve: 'DaySolve'
} as const;
export type TaxiTripAssignmentStrategy = typeof TaxiTripAssignmentStrategy[keyof typeof TaxiTripAssignmentStrategy];

